import { graphql, useMutation } from "react-relay";
import { useWorkspaceSignalEditAddFileMutation } from "./__generated__/useWorkspaceSignalEditAddFileMutation.graphql";

export function useWorkspaceSignalEditRemoveFile() {
  const [removeFiles] = useMutation<useWorkspaceSignalEditAddFileMutation>(
    graphql`
      mutation useWorkspaceSignalEditRemoveFileMutation(
        $signalWorkspaceId: ID!
        $fileIds: [ID!]!
      ) {
        signalWorkspace(id: $signalWorkspaceId) {
          removeFiles(fileIds: $fileIds) {
            id
            ...WorkspaceSignalEditMainEditedInfo_Signal
            descriptionFiles {
              id
            }
          }
        }
      }
    `
  );

  return (signalWorkspaceId: string, fileIds: string[]) => {
    removeFiles({
      variables: {
        signalWorkspaceId,
        fileIds,
      },
    });
  };
}
